import { Outlet } from 'react-router-dom';

export const DiningKitchenOutlet = () => <Outlet />;
